// extracted by mini-css-extract-plugin
export default {"subscribe":"subscribe_subscribe__E0Iow"};